import axios from "axios";
import { getToken } from "./setToken";
import { Promise } from "core-js";
import { Message } from "element-ui";
import $router from "@/router";
const service = axios.create({
  baseURL: "",
  timeout: 10000,
});

//请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = getToken("token");
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//响应拦截器
service.interceptors.response.use(
  (response) => {
    let { code, msg } = response.data;

    code != 200 && Message.error(msg);
    if (response.data.code == 401) {
      const loginUrl = getToken("loginUrl");
      $router.replace(loginUrl);
      // $router.push("/")
    }
    return response;
  },
  (error) => {
    console.log(error, "----------error----------------");

    Message.error(error);
    if (error.response.status) {
    }
    return Promise.reject(error);
  },
);

export default service;
